import { render, staticRenderFns } from "./configTable.vue?vue&type=template&id=0aecd3f9&scoped=true"
import script from "./configTable.vue?vue&type=script&lang=js"
export * from "./configTable.vue?vue&type=script&lang=js"
import style0 from "./configTable.vue?vue&type=style&index=0&id=0aecd3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aecd3f9",
  null
  
)

export default component.exports